import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsService } from '../../constants/constants.service';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  fontSizeIncrementor: number;
  isGrayscale: any;
  isHighContrast: any;

  currentRoute: string = '';
  user: any = {};

  constructor(private router: Router, private constants: ConstantsService) {
   
  }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  isActive(route: string): boolean {
    return this.currentRoute === `/${route}`;
  }

  checkUserLogin() {
    const storage = this.constants.getSessionStorage();
    if (storage && storage.getItem('currentUser')) {
      // Parse the user data from sessionStorage and assign it to the user object
      this.user = JSON.parse(storage.getItem('currentUser') || '{}');
      return true;
    } else {
      return false;
    }
  }
  

  logout() {
    const storage = this.constants.getSessionStorage();
    if (storage && storage.getItem('currentUser')) {
      storage.removeItem('currentUser');
      storage.clear();
      this.user = {}; // Clear user data
      this.router.navigate(['/']);
    }
  }
  

  skipToContent() {
    const mainContent = document.querySelector('main');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
      (mainContent as HTMLElement).focus();
    }
  }

  skipToNavigation() {
    const navigation = document.querySelector('nav');
    if (navigation) {
      navigation.scrollIntoView({ behavior: 'smooth' });
      (navigation as HTMLElement).focus();
    }
  }


  toggleGrayScale() {
    document.body.classList.toggle('gray-scale');
  }


  adjustTextSize(action: string) {
    const root = document.documentElement;
    const currentSize = parseFloat(getComputedStyle(root).fontSize);
    if (action === 'increase') {
      root.style.fontSize = `${currentSize + 2}px`;
    } else if (action === 'decrease') {
      root.style.fontSize = `${currentSize - 2}px`;
    } else if (action === 'reset') {
      root.style.fontSize = '';
    }
  }


  changeLanguage(event: Event) {
    const selectElement = event.target as HTMLSelectElement; // Cast the target to HTMLSelectElement
    const selectedLanguage = selectElement.value;
    console.log(`Selected language: ${selectedLanguage}`);
    // Perform additional logic for language change
  }



  toggleHighContrast() {
   
    this.isHighContrast = !this.isHighContrast;
    if (this.isHighContrast) {
      document.body.classList.add('high-contrast');
    } else {
      document.body.classList.remove('high-contrast');
    }
  }

  toggleGrayscale() {
    
    this.isGrayscale = !this.isGrayscale;
    if (this.isGrayscale) {
      document.body.classList.add('grayscale');
    } else {
      document.body.classList.remove('grayscale');
    }
  }

  increaseFontSize() {
    if (this.fontSizeIncrementor >= 3) {
      return;
    }
    this.fontSizeIncrementor++;
    document.querySelector('body').className = '';
    document.querySelector('body').className = 'font-size' + this.fontSizeIncrementor;
  }

  decreaseFontSize() {
    if (this.fontSizeIncrementor <= -3) {
      return;
    }
    this.fontSizeIncrementor--;
    document.querySelector('body').className = '';
    document.querySelector('body').className = 'font-size' + this.fontSizeIncrementor;
  }

  resetFontSize() {
    this.fontSizeIncrementor = 0;
    document.querySelector('body').className = '';
  }

 
openApplicantModal(): void {
  // First navigate to the employee page
  this.router.navigate(['/empolyee']).then(() => {
    // After navigation, open the modal
    setTimeout(() => {
      const el = document.getElementById('applicantVideoModal');
      if (el) {
        const modal = new bootstrap.Modal(el);
        modal.show();
      }
    }, 300); // small delay so the page renders first
  });
}

goToApplicantLogin(): void {
  // Stop video
  const iframe = document.getElementById('applicantYoutubeFrame') as HTMLIFrameElement;
  if (iframe) { iframe.src = iframe.src; }
  // Just close modal — user is already on employee page
  const el = document.getElementById('applicantVideoModal');
  if (el) {
    const modal = bootstrap.Modal.getInstance(el);
    if (modal) modal.hide();
  }
}

}


